module.exports = __webpack_public_path__ + "img/3.c536e486.png";